<script lang="ts">
  import { onMount } from "svelte";
  import { ApiService } from "../../services/api.service";
	import BlueButton from "../BlueButton.svelte";

	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import SectionBoard from "../../molecules/SectionBoard.svelte";

	let loading = false

	let name = ''
	let html = ''

	const handleName = (event) => {
		name = event.detail.value
	}

	const handleHtml = (event) => {
		html = event.detail.value
	}

	onMount(async () => {
		const client = ApiService.createClient()
		const { data } = await client.get('/fixedPage/termsOfService')
		if (!data.fixedPage) {
			return
		}
		name = data.fixedPage.name
		html = data.fixedPage.html
	})

	const saveLine = async () => {
		const client = ApiService.createClient()
		loading = true
		const { data } = await client.post('/fixedPage', {
			category: "termsOfService",
			name,
			html
		})
		console.log(data)
		loading = false
	}
</script>

<SectionBoard>
	<h2 class="font-semibold">
		利用規約
	</h2>

	<div class="mt-6">
		<FormWithLabel
			label="名前"
			placeholder=""
			input={handleName}
			value={name}
		/>
	</div>

	<div class="mt-6">
		<FormWithLabel
			label="利用規約"
			input={handleHtml}
			value={html}
			inputType="textarea"
		/>
	</div>

	<BlueButton rounded klass="mt-4" click={saveLine} loading={loading}>
		更新する
	</BlueButton>
</SectionBoard>